// extracted by mini-css-extract-plugin
export default {"signingInfoContainer":"Form_signingInfoContainer__C+bAb"};